module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_1_0.5b3ceb40.png";